import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import RootRef from '@material-ui/core/RootRef';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import { addNotification } from 'redux/modules/notifications';

import ScheduleCalendarRow from './ScheduleCalendarRow';

const styles = () => ({
  root: {
    minWidth: 500,
  },
});

const boundsSelectorId = 'schedule-calendar-table';

class ScheduleCalendarTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cells: [],
      activeCellID: null,
      activeCellNotAllowed: false,
      dropItem: null,
    };

    this.onItemDrag = this.onItemDrag.bind(this);
    this.onItemStopDrag = this.onItemStopDrag.bind(this);
    this.onCellsUpdate = this.onCellsUpdate.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.onCellsUpdate();
    }, 200);
  }

  componentWillReceiveProps(nextProps) {
    const { loading, disabled } = this.props;
    if ((loading === true && nextProps.loading === false)
      || (disabled === true && nextProps.disabled === false)) {
      this.setState({
        activeCellID: null,
        dropItem: null,
      });
      setTimeout(() => {
        this.onCellsUpdate();
      }, 200);
    }
  }

  onItemDrag({ x, y }) {
    const { onItemDrag } = this.props;
    const { cells } = this.state;
    const activeCell = cells.find(cell =>
      x >= cell.x && x < (cell.x + cell.width) && y >= cell.y && y < (cell.y + cell.height));
    onItemDrag({ x, y });
    if (activeCell) {
      this.setState({
        activeCellID: activeCell.ID,
        activeCellNotAllowed: activeCell.notAllowed,
      });
    }
  }

  onItemStopDrag({ item }) {
    const { onOrderLinesUpdate, items, variant, actions } = this.props;
    const { activeCellID } = this.state;
    let activeCellDate;
    let activeCellDriverID;
    let activeCellNotAllowed = false;
    items.forEach((row) => {
      row.items.forEach((cell) => {
        if (activeCellID === cell.ID
          && !cell.items.find(cellItem =>
            cellItem.ID === item.ID
            || cellItem['Order Line']
              .map(orderLine => orderLine.ID).indexOf(Number(item.ID)) !== -1)) {
          activeCellDate = cell.date;
          if (variant === 'single-date') {
            if (row.Active === false) {
              activeCellNotAllowed = true;
            }
            activeCellDriverID = row.ID;
          }
        }
      });
    });
    if (activeCellNotAllowed) {
      setTimeout(() => {
        actions.addNotification({
          message: 'Driver is Inactive',
          variant: 'warning',
        });
      }, 200);
      this.setState({
        activeCellID: null,
        activeCellNotAllowed: false,
      });
    } else if (activeCellDate) {
      onOrderLinesUpdate(item['Order Line'].map(orderLine => ({
        ID: orderLine.ID,
        orderID: orderLine['Order ID'],
        'Date of Delivery': activeCellDate,
        ...variant === 'single-date' ? {
          ...activeCellDriverID ? { 'Driver ID': activeCellDriverID } : { 'Driver ID': null },
        } : {},
      })));
      this.setState({
        dropItem: item,
        activeCellNotAllowed: false,
      });
    } else {
      this.setState({
        activeCellID: null,
        activeCellNotAllowed: false,
      });
    }
  }

  onCellsUpdate() {
    if (this.rootRef) {
      const rootDomRect = this.rootRef.getBoundingClientRect();
      const cellsNodeList = this.rootRef.querySelectorAll('td[data-cell]');
      const cells = [...cellsNodeList].map((cellNode) => {
        const ID = cellNode.getAttribute('id');
        const notAllowed = cellNode.getAttribute('data-not-allowed');
        const cellNodeDOMRect = cellNode.getBoundingClientRect();
        return {
          ID,
          notAllowed: notAllowed === 'true',
          x: cellNodeDOMRect.left - rootDomRect.left,
          y: cellNodeDOMRect.top - rootDomRect.top,
          width: cellNodeDOMRect.width,
          height: cellNodeDOMRect.height,
        };
      });
      this.setState({ cells });
    }
  }

  render() {
    const {
      variant,
      loading,
      disabled,
      business,
      onRowHeadClick,
      onOrderLinesToggle,
      onDisableDrag,
      onEnableDrag,
      onSign,
      classes,
    } = this.props;
    let { items } = this.props;
    const { activeCellID, dropItem, activeCellNotAllowed } = this.state;
    if (activeCellID) {
      if (dropItem) {
        items = items.map(row => ({
          ...row,
          items: row.items.map(cell => ({
            ...cell,
            items: cell.items.map((item) => {
              if (item.ID === dropItem.ID) {
                return {
                  ...item,
                  hidden: true,
                };
              }
              return {
                ...item,
                'Order Line': item['Order Line'].map((orderLine) => {
                  if (orderLine.ID === Number(dropItem.ID)) {
                    return {
                      ...orderLine,
                      hidden: true,
                    };
                  }
                  return orderLine;
                }),
              };
            }),
          })),
        }));
        items = items.map(row => ({
          ...row,
          items: row.items.map((cell) => {
            if (cell.ID === activeCellID) {
              const mergeItem = variant === 'date-range'
                ? cell.items.find(cellItem =>
                  cellItem['Order Line'][0]['Order ID'] === dropItem['Order Line'][0]['Order ID']
                  && cellItem['Order Line'][0].Driver.ID === dropItem['Order Line'][0].Driver.ID
                  && cellItem['Order Line'][0]['Is Delivered'] === dropItem['Order Line'][0]['Is Delivered'])
                : cell.items.find(cellItem =>
                  cellItem['Order Line'][0]['Order ID'] === dropItem['Order Line'][0]['Order ID']
                  && cellItem['Order Line'][0]['Is Delivered'] === dropItem['Order Line'][0]['Is Delivered']);
              if (mergeItem) {
                return {
                  ...cell,
                  items: cell.items.map((cellItem) => {
                    if (cellItem.ID !== mergeItem.ID) {
                      return cellItem;
                    }
                    const newOrderLine = [
                      ...cellItem['Order Line'],
                      ...dropItem['Order Line'],
                    ];
                    return {
                      ...cellItem,
                      ID: newOrderLine.map(orderLine => orderLine.ID).join('-'),
                      'Order Line': newOrderLine,
                    };
                  }),
                };
              }
              return {
                ...cell,
                items: [
                  ...cell.items,
                  ...activeCellID === cell.ID ? [dropItem] : [],
                ],
              };
            }
            return cell;
          }),
        }));
      } else {
        items = items.map(row => ({
          ...row,
          items: row.items.map(cell => ({
            ...cell,
            ...activeCellID === cell.ID ? { active: true } : {},
          })),
        }));
      }
    }
    if (!items) {
      return '';
    }
    return (
      <RootRef
        rootRef={(rootRef) => {
          this.rootRef = rootRef;
        }}
      >
        <Table
          id={boundsSelectorId}
          className={classes.root}
        >
          <TableBody>
            {items.map(item => (
              <ScheduleCalendarRow
                key={item.ID}
                variant={variant}
                disabled={disabled}
                boundsSelector={`#${boundsSelectorId}`}
                onItemStopDrag={this.onItemStopDrag}
                onItemDrag={this.onItemDrag}
                onRowHeadClick={onRowHeadClick}
                onOrderLinesToggle={onOrderLinesToggle}
                loading={loading}
                business={business}
                activeCellNotAllowed={activeCellNotAllowed}
                onDisableDrag={onDisableDrag}
                onEnableDrag={onEnableDrag}
                onSign={onSign}
                {...item}
              />
            ))}
          </TableBody>
        </Table>
      </RootRef>
    );
  }
}

ScheduleCalendarTable.propTypes = {
  variant: PropTypes.oneOf(['single-date', 'date-range']).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
  onOrderLinesUpdate: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onItemDrag: PropTypes.func,
  onOrderLinesToggle: PropTypes.func,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  onRowHeadClick: PropTypes.func,
  actions: PropTypes.shape({
    addNotification: PropTypes.func.isRequired,
  }).isRequired,
  onSign: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

ScheduleCalendarTable.defaultProps = {
  items: null,
  loading: false,
  disabled: false,
  onOrderLinesUpdate: () => {},
  onItemDrag: () => {},
  business: {},
  onRowHeadClick: () => {},
  onOrderLinesToggle: () => {},
  onSign: () => {},
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ addNotification }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(ScheduleCalendarTable)
);



// WEBPACK FOOTER //
// ./src/components/schedule/ScheduleCalendar/ScheduleCalendarTable.js